import { format, isEmpty } from "@swiggy-private/js-utils";
import {
    DINE_CASH_AMOUNT_FORMAT,
    DINE_CASH_SUBCOPY_FORMAT,
    DINE_CASH_SUBCOPY_MAX_REACHED_FORMAT,
    LOTTIE_DYNAMIC_KEYS,
    ScreenImpressionState,
} from "./constants";

//Adding constants for LottieInfoLayoutCard widget type directly instead of importing from @swiggy-private/dls-react-mxn/dist/WidgetController/constants as it is pulling whole module which is not needed.
const DIMENSION_TYPE_RELATIVE = "TYPE_RELATIVE";
const RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH = "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH";
const LOTTIE_INFO_LAYOUT_CARD_WIDGET_TYPE = "type.googleapis.com/swiggy.gandalf.widgets.v2.LotteInfoLayoutCard";

export const isMaxPoolAmountReached = (totalAmountReceived?: number, maxPoolAmountAllowed?: number): boolean => {
    if (isEmpty(totalAmountReceived) || isEmpty(maxPoolAmountAllowed)) {
        return false;
    }
    return (totalAmountReceived ?? 0) >= (maxPoolAmountAllowed ?? 0);
};

export const getLottieInfoProp = ({
    url,
    totalAmountReceived,
    maxPoolAmountAllowed,
    maxAmountReached,
}: {
    url: string;
    totalAmountReceived?: number;
    maxPoolAmountAllowed?: number;
    maxAmountReached?: boolean;
}) => {
    const subcopyValue = maxAmountReached
        ? DINE_CASH_SUBCOPY_MAX_REACHED_FORMAT
        : format(DINE_CASH_SUBCOPY_FORMAT, maxPoolAmountAllowed);
    return {
        position: 0,
        isLastCard: true,
        info: [
            {
                id: "1",
                lotteUrl: url,
                dynamicInfoV2: [
                    {
                        key: LOTTIE_DYNAMIC_KEYS.AMOUNT,
                        dynamicValue: {
                            value: format(DINE_CASH_AMOUNT_FORMAT, totalAmountReceived),
                        },
                    },
                    {
                        key: LOTTIE_DYNAMIC_KEYS.SUBCOPY,
                        dynamicValue: {
                            value: subcopyValue,
                        },
                    },
                ],
            },
        ],
        style: {
            width: {
                type: DIMENSION_TYPE_RELATIVE,
                value: 1,
                reference: RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH,
            },
        },
        "@type": LOTTIE_INFO_LAYOUT_CARD_WIDGET_TYPE,
    };
};

export const formatText = (text: string, maxPerPersonCap?: number, maxPoolAmountAllowed?: number) => {
    return text
        .split("{maxPerPersonCap}")
        .join(maxPerPersonCap?.toString() || "")
        .split("{maxPoolAmountAllowed}")
        .join(maxPoolAmountAllowed?.toString() || "");
};

export const generateQRCodeImageUrl = (base64Image: string) => {
    return `data:image/png;base64,${base64Image}`;
};

export const getScreenImpressionState = (
    maxAmountReached: boolean,
    totalAmountReceived?: number,
): ScreenImpressionState => {
    if (maxAmountReached) return ScreenImpressionState.LIMIT_REACHED;
    if (totalAmountReceived) return ScreenImpressionState.RECEIVED;
    return ScreenImpressionState.DEFAULT;
};
